import s from './Gallery.module.css';
import { NavigationHeader } from 'components/NavigationHeader/NavigationHeader';
import { BackButton } from 'components/BackButton/BackButton';
import { GalleryLabel } from 'components/MenuLabels/GalleryLabel/GalleryLabel';
import { useLocation } from 'react-router-dom';
import { UploadButton } from 'components/UploadButton/UploadButton';
import { SelectOrder } from 'components/SelectOrder/SelectOrder';
import { SelectType } from 'components/SelectType/SelectType';
import { SelectBreeds } from 'components/SelectBreeds/SelectBreeds';
import { SelectLimit } from 'components/SelectLimit/SelectLimit';
import { RefreshButton } from 'components/RefreshButton/RefreshButton';
import { fetchAllBreeds } from 'services/API/API';
import { CatsCollection } from 'components/CatsCollection/CatsCollection';
import { useState } from 'react';
import { useEffect } from 'react';
import { LabelStyleGallery } from 'components/CatsCollection/LabelStyleGallery';

const Gallery = () => {
  const { pathname } = useLocation();

  const [order, setOrder] = useState('random');
  const [type, setType] = useState('');
  const [breed, setBreed] = useState('None');
  const [limit, setLimit] = useState(10);
  const [images, setImages] = useState([]);

  const [refresh, setRefresh] = useState(true);

  const orderHandler = value => {
    setImages([]);
    setOrder(value);
  };

  const typeHandler = value => {
    console.log(type, value);
    value !== type && setImages([]);
    setType(value);
  };

  const breedHandler = value => {
    value !== breed && setImages([]);
    setBreed(value);
  };

  const limitHandler = value => {
    value !== limit && setImages([]);
    setLimit(value);
  };

  const refreshHandler = () => {
    setImages([]);
    setRefresh(prev => !prev);
  };

  useEffect(() => {
    breed === 'None'
      ? fetchAllBreeds(limit, '', order, type).then(data => setImages(data))
      : fetchAllBreeds(limit, breed, order, type).then(data => setImages(data));
  }, [limit, breed, type, order, refresh]);

  return (
    <div className={s.main}>
      <div>
        <NavigationHeader />
      </div>
      <div className={s.container}>
        <div className={s.buttons}>
          <BackButton path={'/'} state={{ from: { pathname } }} />
          <GalleryLabel />
          <UploadButton />
        </div>
        <div className={s.select__panel}>
          <div className={s.select__order}>
            <SelectOrder onSelect={orderHandler} />
            <SelectType onSelect={typeHandler} />
          </div>
          <div className={s.select__order__second_line}>
            <SelectBreeds
              onSelect={breedHandler}
              startListValue={{ name: 'None', label: 'None', id: 1 }}
            />
            <SelectLimit onSelect={limitHandler} />
            <RefreshButton onClick={refreshHandler} />
          </div>
        </div>
        <CatsCollection
          images={images}
          numberImages={limit}
          destination={'gallery'}
          actualSyleLabelHover={LabelStyleGallery}
        />
      </div>
    </div>
  );
};

export { Gallery };
